import React, { Component, PureComponent } from 'react';
import { Accordion, Checkbox, Stepper, Steps } from 'antd-mobile';
import tips from 'tips';
import addval_icon from './asstes/addval_icon.jpg';
import attach_icon from './asstes/attach_icon.jpg';
import TicPopUp from 'TicPopUp';
import './index.less';
import flight from './asstes/arrow2.png';
import { getCode3Widget } from '@csair/emp-helpers';
import { object } from 'prop-types';
import tip2 from './asstes/tip2.png';

const Step = Steps.Step;

const CheckboxItem = Checkbox.CheckboxItem;
const Panel = Accordion.Panel;

export class AnnexHeader extends PureComponent {
  render() {
    const { lang } = this.props;
    return (
      <div className="title">
        <img src={attach_icon} alt="" />
        <span>{lang.additional}</span>
        {this.props.children}
      </div>
    );
  }
}

export function AddValHeader() {
  return (
    <div className="title">
      <img src={addval_icon} alt="" />
      <span>增加产品</span>
    </div>
  );
}

class Compute extends PureComponent {
  state = {
    num: this.props.value,
  };

  _handleOperate = type => () => {
    this.setState(
      state => {
        if (type === 'add' && this.props.max > state.num) {
          return {
            num: state.num + 1,
          };
        }
        if (type === 'cut' && state.num > this.props.min) {
          return {
            num: state.num - 1,
          };
        }
      },
      () => {
        this.props.change(this.state.num);
      }
    );
  };

  componentWillReceiveProps(newProps) {
    this.setState({ num: newProps.value });
  }

  render() {
    return (
      <div className="compute">
        <div role="button" onClick={this._handleOperate('cut')}>
          -
        </div>
        <div>{this.state.num}</div>
        <div role="button" onClick={this._handleOperate('add')}>
          +
        </div>
      </div>
    );
  }
}

class DriveCompute extends PureComponent {
  state = {
    numD: this.props.value,
  };

  _handleOperateD = type => () => {
    this.setState(
      state => {
        if (type === 'add' && this.props.max > state.numD) {
          return {
            numD: state.numD + 1,
          };
        }
        if (type === 'cut' && state.numD > this.props.min) {
          return {
            numD: state.numD - 1,
          };
        }
      },
      () => {
        this.props.changeNum(this.state.numD);
      }
    );
  };

  componentWillReceiveProps(newProps) {
    this.setState({ numD: newProps.value });
  }

  render() {
    return (
      <div className="compute">
        <div role="button" onClick={this._handleOperateD('cut')}>
          -
        </div>
        <div>{this.state.numD}</div>
        <div role="button" onClick={this._handleOperateD('add')}>
          +
        </div>
      </div>
    );
  }
}

class ProductSelector extends Component {
  static defaultProps = {
    /**
     * @description 操作方式
     * @example
     *  edit: 编辑
     *  read: 读 (默认)
     *  detail: 详情
     */
    operate: 'read', // 是否展示操作按钮，当为false只展示
    title: '',
    remark: '',
    minTitle: '',
    data: [
      // {
      //   text: '广州 - 北京轻轨票',
      //   type: 'num',
      //   max: 3,
      //   value: 0,
      //   unit: '张',
      // },
      // {
      //   text: '休息室',
      //   type: 'checkbox',
      //   value: false,
      //   unit: '份',
      // },
    ],
    otherItem: null,
    onChange: (index, val) => {},
    trainlist: [],
    hotelNationArr: [],
    hotelSummary: '',
    airportTransferList: [],
  };

  state = {
    activeKey: !this.props.data || !this.props.data.length ? ['panel'] : [],
    setStatus: [],
    bagStatus: [],
    bidStatus: [],
    roomStatus: {}, // key vale
    val: 0,
    htProduct: [], //hotel
    trainProduct: [], //train
    doorToDoorList: [],
    doorNum: {},
    doorActive: [],
    canCheck: 0,
    // trainKey: this.props.trainlist.length ? ['panel'] : [],
  };

  _changeData = index => val => {
    this.props.onChange(index, val);
  };

  _onChangeAnteroom = key => val => {
    this.setState({
      roomStatus: {
        ...this.state.roomStatus,
        [key]: val,
      },
    });
    // return data;
  };

  _onChangeDrive = (key, item) => val => {
    this.setState({
      doorNum: {
        ...this.state.doorNum,
        [key]: val,
      },
    });
    console.log(Object.keys(this.state.doorNum), val);
  };

  getDoorList = () => {
    const { doorNum, doorToDoorList } = this.state;
    let doorArr = [];
    Object.keys(doorNum).forEach(key => {
      for (let index = 0; index < doorNum[key]; index++) {
        doorArr.push(doorToDoorList[key]);
      }
    });
    return doorArr;
  };

  _renderText = data => {
    return (
      <div className="productItem">
        <div className={`text ${data.soStyle ? data.soStyle : ''}`}>
          {data.text}
        </div>
        <div className="num">{`${data.type === 'num' ? data.value : '0'}${
          data.unit
        }`}</div>
      </div>
    );
  };

  _renderItem = (data, index) => {
    return (
      <div className="productItem">
        <div className="text">{data.text}</div>
        <div>
          {data.type === 'num' && (
            <Compute
              value={data.value}
              max={data.max}
              min={data.min}
              change={this._changeData(index)}
            />
          )}
          {data.type === 'checkbox' && (
            <div className="select">
              <CheckboxItem
                defaultChecked={data.value}
                className="am-checkbox-reset-gray"
                onChange={this._changeData(index)}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  selectAllDoor = (e, selectDoor) => {
    const { doorToDoorList, canCheck, doorActive } = this.state;

    let doorObj = {};
    if (selectDoor.length === 0) {
      doorToDoorList.forEach((it, index) => {
        doorObj[index] = it.numMax;
      });
    }

    this.setState({
      doorNum: doorObj,
      // canCheck: canCheck + 1
    });
    if (doorActive.length !== 0 || selectDoor.length !== 0) {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  renderDoorTitle = selectDoor => {
    const { lang } = this.props;
    return (
      <div className="">
        <div className="doorheader">
          <div style={{ fontWeight: 'bold' }}>{lang.refCuponDoor}</div>
          <div
            className="zxczxc"
            role="button"
            onClick={e => this.selectAllDoor(e, selectDoor)}
          >
            {selectDoor.length === 0 && <div className="bgcvcc" />}
            {selectDoor.length > 0 && <div className="bgcvv" />}
          </div>
        </div>
      </div>
    );
  };

  selectAccordion = (close = false) => key => {
    console.log(close);
    if (!close) return false;
    this.setState({
      doorActive: key,
    });
  };

  onChange = key => {
    const { data, soData } = this.props;
    if (
      (!data || !data.length) &&
      (soData === null || Object.keys(soData).length !== 0)
    )
      return;
    this.setState({ activeKey: key });
  };

  // changeTap = key => {
  //   const { trainlist } = this.props;
  //   if (!trainlist.length) return;
  //   this.setState({ trainKey: key });
  // }

  changeDoor = key => {
    console.log(key);
    // event.stopPropagation();
  };

  formateArray = (origin, val) => {
    return val.reduce((p, n) => {
      const i = p.indexOf(n);
      if (i >= 0) {
        p.splice(i, 1);
        return p;
      }
      return p.concat(n);
    }, origin);
  };

  onSelectAll = key => {
    let type = '';
    if (key === 'setStatus') type = 'sselection';
    if (key === 'bagStatus') type = 'baggage';
    if (key === 'roomStatus') type = 'anteroom';
    if (key === 'bidStatus') type = 'biddingAmend';
    this.setState({
      [key]:
        this.state[key].length < this.props.soData[type].length
          ? this.props.soData[type].map(item => item.psgname + item.segOrder)
          : [],
    });
  };

  onSelect = (type, val) => {
    if ((type = 'bidStatus')) return;
    this.setState({
      [type]: val.reduce((p, n) => {
        const i = p.indexOf(n);
        // const i = JSON.stringify(p).indexOf(JSON.stringify(n));
        if (i >= 0) {
          p.splice(i, 1);
          return p;
        }
        return p.concat(n);
      }, this.state[type]),
    });
  };

  selectAllTrain = () => {
    let arr =
      this.state.trainProduct.length < this.props.trainlist.length
        ? this.props.trainlist.map(item => item.xname)
        : [];
    this.setState({
      trainProduct: arr,
    });
    this.props.checkTrainBox(arr);
  };

  onSelectTrain = val => {
    let arr = val.reduce((p, n) => {
      const i = p.indexOf(n);
      if (i >= 0) {
        p.splice(i, 1);
        return p;
      }
      return p.concat(n);
    }, this.state.trainProduct);
    this.setState({
      trainProduct: arr,
    });
    this.props.checkTrainBox(arr);
  };

  selectHotel = (e, val) => {
    const { flightCheckBoxData, flightRele, lang } = this.props;
    let htValue = [];
    if (flightCheckBoxData.length === 0 && !this.state.htProduct.length) {
      TicPopUp(lang.title, lang.endorsedApply.pleaseSelectHtlight);
    }
    // 强关联
    if (flightCheckBoxData.length && flightRele) {
      htValue.push(val);
    }
    if (e.target.checked) {
      htValue.push(val);
    }
    this.setState({
      htProduct: htValue,
    });
  };

  getHotelData = () => {
    return this.state.htProduct;
  };

  getTrainData = () => {
    return this.state.trainProduct;
  };

  getSelectData = () => {
    const data = {};
    Object.keys(this.props.soData).forEach(key => {
      let type = '';
      if (key === 'sselection') type = 'setStatus';
      if (key === 'baggage') type = 'bagStatus';
      if (key === 'anteroom') type = 'roomStatus';
      if (key === 'biddingAmend') type = 'bidStatus';

      if (key === 'anteroom') {
        const room = this.makeAnterRoom(this.props.soData[key] || []);
        data[key] = Object.keys(room).reduce((a, b) => {
          return a.concat(
            room[b].slice(0, this.state[type][b] ? this.state[type][b] : 0)
          );
        }, []);
        return false;
      }
      data[key] = this.props.soData[key].filter(item =>
        this.state[type].includes(item.psgname + item.segOrder)
      );
    });

    let totalCount = 0;
    Object.keys(data).forEach(key => {
      totalCount += data[key].length;
    });

    // if (totalCount === 0) return null;
    if (totalCount === 0) return {};
    return data;
  };

  makeAnterRoom = arr => {
    return arr.reduce((a, b) => {
      if (!a[b.depAirport]) a[b.depAirport] = [];
      a[b.depAirport].push(b);
      return a;
    }, {});
  };

  componentDidMount() {
    const { psg, soData, trainlist, airportTransferList } = this.props;
    if (airportTransferList && airportTransferList.length > 0) {
      let doorArr = [];
      doorArr = airportTransferList.reduce((obj, item) => {
        console.log(obj, item);
        let find = obj.find(
          i =>
            i.serviceType === item.serviceType &&
            i.carModelName === item.carModelName
        );
        let _d = {
          ...item,
          numMax: 1,
        };
        find ? find.numMax++ : obj.push(_d);
        return obj;
      }, []);
      // });
      this.setState({ doorToDoorList: doorArr });
    }
    if (psg === 1) {
      Object.keys(soData).forEach(key => {
        let type = '';
        if (key === 'anteroom') {
          type = 'roomStatus';
          this.setState({
            [type]: soData[key].reduce((a, b) => {
              if (!a[b.depAirport]) a[b.depAirport] = 0;
              a[b.depAirport]++;
              return a;
            }, {}),
          });
          return false;
        }
        if (key === 'sselection') type = 'setStatus';
        if (key === 'baggage') type = 'bagStatus';
        if (key === 'biddingAmend') type = 'bidStatus';
        this.setState({
          [type]: soData[key].map(item => item.psgname + item.segOrder),
        });
      });
    }
    if (trainlist && trainlist.length > 0) {
      this.setState({
        trainProduct: trainlist.map(item => item.xname),
      });
      this.props.checkTrainBox(trainlist.map(item => item.xname));
    }
  }

  //  参数变更触发的周期钩子
  componentWillReceiveProps(nextProps) {
    if (!nextProps.data || !nextProps.data.length) {
      if (!this.state.activeKey.length) {
        this.setState({ activeKey: ['panel'] });
      }
    }

    // 此处存在so产品重新渲染组件导致勾选的问题;
    // console.log(this.flightCheckBoxData, nextProps.presonCheckBoxData);
    if (
      nextProps.flightCheckBoxData &&
      this.flightCheckBoxData !== nextProps.flightCheckBoxData
    ) {
      this.setState({
        htProduct:
          nextProps.flightCheckBoxData.length > 0 ? nextProps.hotelData : [],
      });
    }

    const { soData } = nextProps;
    if (soData === null || Object.keys(soData).length === 0) return;
    var changeObj = {};
    Object.keys(soData).forEach(key => {
      let type = '';
      if (key === 'sselection') type = 'setStatus';
      if (key === 'baggage') type = 'bagStatus';
      if (key === 'anteroom') type = 'roomStatus';
      if (key === 'biddingAmend') type = 'bidStatus';
      if (key === 'anteroom') {
        const room = this.makeAnterRoom(soData[key] || []);
        Object.keys(this.state[type]).reduce((a, b) => {
          if (!room[b]) delete this.state[type][b];
          if (room[b] && this.state[type][b] > room[b].length)
            this.state[type][b] = room[b].length;
          changeObj[key] = this.state[type];
        }, {});
        return false;
      }

      if (this.state[type] && this.state[type].length) {
        const arr = soData[key].map(item => item.psgname + item.segOrder);
        changeObj[type] = this.state[type].filter(item => arr.includes(item));
      }
    });

    this.setState(changeObj);
  }

  render() {
    const {
      title,
      minTitle,
      data,
      remark,
      operate,
      otherItem,
      soData,
      hotelData,
      trainlist,
      lang,
      hotelNationArr,
      daxingProduct,
      hotelSummary,
      airportTransferList,
    } = this.props;

    let accordionClassName = 'am-accordion-reset';
    if (title && title.props && title.props.children)
      accordionClassName += ' md-head';
    let proClassName = 'productSelector ' + operate;
    if (
      (!data || !data.length) &&
      (soData === null || Object.keys(soData).length < 0)
    ) {
      proClassName += ' no-open';
    }

    let anteroom = [];
    if (soData !== null) {
      anteroom = soData.anteroom;
    }

    const {
      setStatus,
      bagStatus,
      roomStatus,
      htProduct,
      bidStatus,
      trainProduct,
      doorToDoorList,
      doorNum,
    } = this.state;
    const room = this.makeAnterRoom(anteroom || []);
    const selectDoor = this.getDoorList();
    const hasBob = selectDoor.some(item => item.commissionFee === true);
    return (
      <div className={proClassName}>
        <Accordion
          className={accordionClassName}
          activeKey={this.state.activeKey}
          onChange={this.onChange}
        >
          <Panel key="panel" header={title}>
            <div className="plate">
              <p>{minTitle}</p>
              {data.map((item, index) => {
                if (operate === 'edit') {
                  if (item.show) {
                    if (item.value !== 0) {
                      return this._renderItem(item, index);
                    }
                    return '';
                  } else {
                    return this._renderItem(item, index);
                  }
                }
                return this._renderText(item);
              })}
            </div>
            {hasBob && (
              <div className="doorTip">
                <div>
                  {' '}
                  <img src={tip2} />
                </div>
                <div>
                  本次取消接送机服务可能会产生费用，具体退款金额以客服审核结果为准。
                </div>
              </div>
            )}

            {/* 酒店产品 */}
            <div className="plate htPlate">
              {hotelData.map((item, index) => {
                return (
                  <div className="productItem">
                    <div
                      className="htText"
                      style={{ webkitBoxOrient: `vertical` }}
                    >
                      {item.hotelName}
                    </div>
                    <div className={operate === 'detail' ? 'htNum' : ''}>
                      {' '}
                      {item.manydays}
                      {lang.interval}
                      {item.manynights}
                      {lang.late}
                    </div>
                    {operate === 'edit' ? (
                      <div className="selectht">
                        <CheckboxItem
                          // defaultChecked={flightCheckBoxData.length > 0}
                          key={index}
                          className="am-checkbox-reset-blue"
                          onChange={e => this.selectHotel(e, item)}
                          // onChange={}
                          checked={htProduct.length > 0}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                );
              })}
            </div>

            {/* so产品 */}
            {soData !== null && Object.keys(soData).length !== 0 && (
              <div className="soPlate">
                {soData.sselection && soData.sselection.length !== 0 && (
                  <Accordion className="my-accordion">
                    {operate === 'edit' && (
                      <CheckboxItem
                        className="am-checkbox-reset-blue check_all"
                        onChange={() => {
                          this.onSelectAll('setStatus');
                        }}
                        checked={setStatus.length === soData.sselection.length}
                      />
                    )}
                    <Panel
                      header={lang.paidSeat}
                      className={operate === 'edit' ? 'moreCheck' : 'numCheck'}
                    >
                      <div className="plate">
                        {soData.sselection.map((item, index) => {
                          return (
                            <div className="soProductItem">
                              <div className="text">
                                {getCode3Widget(item.depAirport).cityName} -{' '}
                                {getCode3Widget(item.arrAirport).cityName}{' '}
                                {item.psgname} {item.baggageAndPaidSeat}
                              </div>
                              <div className="select">
                                {operate === 'edit' ? (
                                  <CheckboxItem
                                    key={index}
                                    className="am-checkbox-reset-blue"
                                    // checked={setStatus[index]}
                                    // onChange={e =>
                                    //   this.checkAll(e, 'setStatus', item, index)
                                    // }
                                    onChange={() => {
                                      this.onSelect('setStatus', [
                                        item.psgname + item.segOrder,
                                      ]);
                                    }}
                                    checked={
                                      setStatus.indexOf(
                                        item.psgname + item.segOrder
                                      ) !== -1
                                    }
                                  />
                                ) : (
                                  lang.copy
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Panel>
                  </Accordion>
                )}

                {soData.baggage && soData.baggage.length !== 0 && (
                  <Accordion className="my-accordion">
                    {operate === 'edit' && (
                      <CheckboxItem
                        className="am-checkbox-reset-blue check_all"
                        onChange={() => {
                          this.onSelectAll('bagStatus');
                        }}
                        checked={bagStatus.length === soData.baggage.length}
                      />
                    )}
                    <Panel
                      header={lang.excessBaggage}
                      className={operate === 'edit' ? 'moreCheck' : 'numCheck'}
                    >
                      <div className="plate">
                        {soData.baggage.map((item, index) => {
                          return (
                            <div className="soProductItem">
                              <div className="text">
                                {getCode3Widget(item.depAirport).cityName} -{' '}
                                {getCode3Widget(item.arrAirport).cityName}{' '}
                                {item.psgname} {item.baggageAndPaidSeat}
                              </div>
                              <div className="select">
                                {operate === 'edit' ? (
                                  <CheckboxItem
                                    className="am-checkbox-reset-blue"
                                    // checked={bagStatus[index]}
                                    // onChange={e =>
                                    //   this.checkAll(e, 'bagStatus', item, index)
                                    // }

                                    onChange={() => {
                                      this.onSelect('bagStatus', [
                                        item.psgname + item.segOrder,
                                      ]);
                                    }}
                                    checked={
                                      bagStatus.indexOf(
                                        item.psgname + item.segOrder
                                      ) !== -1
                                    }
                                  />
                                ) : (
                                  lang.copy
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Panel>
                  </Accordion>
                )}
                {soData.anteroom && soData.anteroom.length !== 0 && (
                  <Accordion className="my-accordion">
                    <Panel header={lang.refCupon19} className="numCheck">
                      <div className="plate">
                        {Object.keys(room).map((key, index) => {
                          const item = room[key][0];
                          if (operate === 'edit') {
                            return (
                              <div className="soProductItem">
                                <div className="text">
                                  {getCode3Widget(item.depAirport).airportName}{' '}
                                </div>
                                <Compute
                                  value={roomStatus[key] || 0}
                                  max={room[key].length}
                                  min={0}
                                  change={this._onChangeAnteroom(key)}
                                />
                              </div>
                            );
                          }

                          return this._renderText({
                            text: getCode3Widget(item.depAirport).airportName,
                            value: room[key].length,
                            type: 'num',
                            unit: lang.unit,
                            soStyle: 'textSo',
                          });
                        })}
                      </div>
                    </Panel>
                  </Accordion>
                )}
                {soData.biddingAmend && soData.biddingAmend.length !== 0 && (
                  <div className="plate">
                    {soData.biddingAmend.map((item, index) => {
                      return (
                        <div className="soProductItem">
                          <div className="text">{lang.adjustment}</div>
                          <div className="select">
                            {operate === 'edit' ? (
                              <CheckboxItem
                                className="am-checkbox-reset-blue"
                                onChange={() => {
                                  this.onSelect('bidStatus', [
                                    item.psgname + item.segOrder,
                                  ]);
                                }}
                                checked={
                                  bidStatus.indexOf(
                                    item.psgname + item.segOrder
                                  ) !== -1
                                }
                              />
                            ) : (
                              <span>&yen;{item.totalMoney}</span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
            {hotelNationArr && hotelNationArr.length !== 0 && (
              <div className="plate hotelNaPlate">
                <div className="productItem">
                  <div
                    className="htText"
                    style={{ webkitBoxOrient: `vertical` }}
                  >
                    {hotelSummary.roomNames}
                  </div>
                  <div className={operate === 'detail' ? 'htNum' : ''}>
                    {' '}
                    {hotelSummary.totalRooms}
                    {lang.interval}
                    {hotelSummary.days}
                    {lang.late}
                  </div>
                </div>
              </div>
            )}
            {daxingProduct && daxingProduct.length !== 0 && (
              <div className="plate hotelNaPlate">
                <div className="productItem">
                  <div
                    className="htText"
                    style={{ webkitBoxOrient: `vertical` }}
                  >
                    {hotelSummary.daXingProductName}
                  </div>
                  <div className={operate === 'detail' ? 'htNum' : ''}>
                    {' '}
                    {hotelSummary.daXingProductNumber}
                    {lang.Zhang}
                  </div>
                </div>
              </div>
            )}

            {doorToDoorList && doorToDoorList.length !== 0 && (
              <div className="doorToDoorM">
                <Accordion
                  className="doorToDoor"
                  activeKey={this.state.doorActive}
                  onChange={this.selectAccordion(selectDoor)}
                >
                  <Panel
                    header={this.renderDoorTitle(selectDoor)}
                    className={operate === 'edit' ? 'doorToDoorS' : ''}
                  >
                    <div className="driveProduct">
                      {doorToDoorList.map((item, index) => {
                        return (
                          <div className="driveProductList">
                            <div className="text">
                              <div>
                                {item.carModelName}
                                <span
                                  className={
                                    item.serviceType === '3'
                                      ? 'jieji'
                                      : 'songji'
                                  }
                                >
                                  {item.serviceType === '3'
                                    ? '接机车'
                                    : item.serviceType === '4'
                                    ? '送机车'
                                    : ''}
                                </span>
                              </div>
                              <div>
                                {item.serviceType === '4'
                                  ? item.vehicleUsageTime
                                  : ''}
                              </div>
                            </div>
                            <div className="select">
                              <div className="depDoor">
                                <div className="stepLine">
                                  <div />
                                  <div />
                                </div>
                                <div className="addressName">
                                  {item.departurePlace}
                                </div>
                              </div>
                              <div className="arrDoor">
                                <div className="stepLine">
                                  <div />
                                </div>
                                <div className="addressName">
                                  {item.endAddress}
                                </div>
                              </div>
                              {operate === 'edit' ? (
                                <DriveCompute
                                  value={doorNum[index] || 0}
                                  max={item.numMax}
                                  min={0}
                                  changeNum={this._onChangeDrive(index, item)}
                                />
                              ) : (
                                <div className="showNum">× {item.numMax}</div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Panel>
                </Accordion>
              </div>
            )}

            {trainlist && trainlist.length !== 0 && (
              <div className="trainPlate">
                <Accordion
                  className="my-accordion"
                  defaultActiveKey="1"
                  // activeKey={this.state.trainKey}
                >
                  {operate === 'edit' && (
                    <CheckboxItem
                      className="check_all"
                      onChange={() => {
                        this.selectAllTrain();
                      }}
                      checked={trainlist.length === trainProduct.length}
                    />
                  )}
                  <Panel
                    header={lang.trainTicket}
                    className={operate === 'edit' ? 'moreCheck' : 'numCheck'}
                  >
                    <div className="plate">
                      {trainlist.map((item, index) => {
                        return (
                          <div className="trainProductItem">
                            <div className="text">
                              <div>
                                {item.fromStationName}
                                <img
                                  alt=""
                                  src={flight}
                                  className="flightIcon"
                                />
                                {item.toStationName}
                              </div>
                              <div>
                                {' '}
                                {item.xname} | {item.trainDate} {item.startTime}{' '}
                                | {item.trainCode}
                              </div>
                            </div>
                            <div className="select">
                              {operate === 'edit' ? (
                                <CheckboxItem
                                  key={index}
                                  // className="am-checkbox-reset-blue"
                                  onChange={() => {
                                    this.onSelectTrain([item.xname]);
                                  }}
                                  checked={
                                    trainProduct.indexOf(item.xname) !== -1
                                  }
                                />
                              ) : (
                                lang.copy
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Panel>
                </Accordion>
              </div>
            )}

            {!hotelSummary && otherItem}
            {!hotelSummary && remark}
          </Panel>
        </Accordion>
      </div>
    );
  }
}

export default ProductSelector;



// WEBPACK FOOTER //
// ./src/components/ProductSelector/index.js